import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../lib/services/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  title = "mouse-hover";
  showNotificationText = false;
  showProfileText = false;
  showOrderText = false;
  showHomeText = false;
  showMyQrText = false;

  constructor(
    private router: Router,
    private commonService: CommonService
  ) { }

  showProfile(show: boolean) {
    this.showProfileText = show;
  }

  showNotification(show: boolean) {
    this.showNotificationText = show;
  }

  showOrder(show: boolean) {
    this.showOrderText = show;
  }

  showHome(show: boolean) {
    this.showHomeText = show;
  }

  showMyQr(show: boolean) {
    this.showMyQrText = show;
  }

  ngOnInit() { }

  goToOrder() {
    this.router.navigate(['/order']);
  }

  gotoMyQr() {
    this.router.navigate(['/profile/my-qr']);
  }

  goToNotification() {
    this.router.navigate(['/notification'])
  }

  notAvailable() {
    this.commonService.featureNotAvailable();
  }

  walletPage() {
    this.router.navigate(['/wallet-page']);
  }
}
